import { render, staticRenderFns } from "./addWayConfig.vue?vue&type=template&id=81275658&"
import script from "./addWayConfig.vue?vue&type=script&lang=js&"
export * from "./addWayConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81275658')) {
      api.createRecord('81275658', component.options)
    } else {
      api.reload('81275658', component.options)
    }
    module.hot.accept("./addWayConfig.vue?vue&type=template&id=81275658&", function () {
      api.rerender('81275658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gateway/components/addWayConfig.vue"
export default component.exports